import { CNPJ } from 'cpf_cnpj'
import moment from 'moment'

const EMAIL_REGEXP = /\S+@\S+\.\S+/
const EMPTY_STRING_REGEXT = /^\s*$/

export const validateEmail = (email) => EMAIL_REGEXP.test(email)

export const isString = (value) => typeof value === 'string'

export const isArray = (value) => Array.isArray(value)

export const isObject = (value) => typeof value === 'object'

export const isFunction = (value) => typeof value === 'function'

// Null and undefined is not defined
export const isDefined = (value) => value !== null && value !== undefined

export const isEmpty = (value) => {
  // Null and undefined is blank
  if (!isDefined(value)) {
    return true
  }

  // Functions is not blank
  if (isFunction(value)) {
    return false
  }

  // Empty strings is blanks
  if (isString(value)) {
    return EMPTY_STRING_REGEXT.test(value)
  }

  // Arrays without values is blank
  if (isArray(value)) {
    return value.length === 0
  }

  // Object without keys is blank
  if (isObject(value)) {
    return Object.keys(value).length === 0
  }
}

// Creates an object with fields that have values only
export const isKeys = (value) =>
  Object.keys(value).reduce((obj, name) => {
    const field = value[name]

    if (!isEmpty(field)) {
      obj[name] = field
    }

    return obj
  }, {})

export const isCnpjValid = (cnpj) => CNPJ.isValid(cnpj)

export const formatDate = (date) => (!date ? '-' : moment(date).format('L'))

export const formatDateTime = (date) =>
  !date ? '-' : moment(date).format('DD/MM/YYYY HH:mm:ss')

export const arraysEqual = (a = [], b = []) => {
  if (a === b) return true

  const aLength = a.length

  if (aLength !== b.length) return false

  a.sort()
  b.sort()

  for (let i = 0; i < aLength; ++i) {
    if (a[i] !== b[i]) return false
  }

  return true
}

export const objectsEqual = (a = {}, b = {}) => {
  const aKeys = Object.keys(a)
  const bKeys = Object.keys(b)

  if (aKeys.some((key) => !b.hasOwnProperty(key) || b[key] !== a[key]))
    return false
  if (bKeys.some((key) => !a.hasOwnProperty(key) || a[key] !== b[key]))
    return false
  return true
}

export const hasEmptyProperties = (object) =>
  !Object.keys(object).some((key) => object[key] !== '')
